import * as React from 'react';
import { Text, View } from 'react-native';

import { getLocalizedTexts } from '../../../Locales';
import { styles } from './Styles';

// "Version B" (GRW-252) stepper used by the vertical instruction screens: the active section is a black
// rounded pill with white text, the inactive section is greyed-out text, joined by a thin connector line.
export function VerticalStepper({ currentStep }: { currentStep: number }) {
    const texts = getLocalizedTexts().mobileSafariExtensionInstallationPagesRevamped.header;
    return (
        <View style={styles.containerVerticalStepper}>
            <VerticalStepperLabel label={texts.left} isActive={currentStep === 0} />
            <View style={styles.verticalStepperConnector} />
            <VerticalStepperLabel label={texts.right} isActive={currentStep === 1} />
        </View>
    );
}

function VerticalStepperLabel({ label, isActive }: { label: string; isActive: boolean }) {
    return (
        <View style={[styles.verticalStepperLabel, isActive ? styles.verticalStepperLabelActive : undefined]}>
            <Text style={[styles.verticalStepperLabelText, isActive ? styles.verticalStepperLabelTextActive : undefined]}>
                {label}
            </Text>
        </View>
    );
}
